import moment from "moment";
import { User } from "src/app/core/models/auth.models";

export enum IntegrationType {
  DRAWIO = "DRAWIO",
}
export class FileModel {
  public id: number;

  public originalname: string;
  public filename: string;
  public destination: string;
  public encoding: string;
  public mimetype: string;
  public path: string;
  public size: number;
  public url: string;
  public urlSanitize: any;
  public integration: IntegrationType | null;

  public uploadById: number;
  public needFileId: number | null;
  public projectRequestId: number | null;
  public projectId: number | number;
  public requirementFileId: string;
  public taskId: number | null;
  public meetingId: number | null;
  public commentId: number | null;
  public budgetId: number | null;
  public artifactId: number | null;
  public contractId: number | null;
  public productId: number | null;
  public proposalId: number | null;
  public templateId: number | null;
  public eventFileId: number | null;
  public wikiId: number | null;
  public tripId: number | null;

  public uploadBy: User | null;

  public deleted: boolean;
  public createdAt: Date;
  public deletedAt: Date | null;

  constructor($obj?: any) {
    this.id = $obj ? $obj.id : '#new' + moment().valueOf();

    this.originalname = $obj && $obj.originalname ? $obj.originalname : '';
    this.filename = $obj && $obj.filename ? $obj.filename : '';
    this.destination = $obj && $obj.destination ? $obj.destination : '';
    this.encoding = $obj && $obj.encoding ? $obj.encoding : '';
    this.mimetype = $obj && $obj.mimetype ? $obj.mimetype : '';
    this.path = $obj && $obj.path ? $obj.path : '';
    this.size = $obj && $obj.size ? $obj.size : 0;
    this.url = $obj && $obj.url ? $obj.url : null;
    this.urlSanitize = $obj && $obj.urlSanitize ? $obj.urlSanitize : null;
    this.integration = $obj && $obj.integration ? $obj.integration : null;

    this.uploadById = $obj && $obj.uploadById ? $obj.uploadById : $obj && $obj.uploadBy ? $obj.uploadBy.id : null;
    this.needFileId = $obj && $obj.needFileId ? $obj.needFileId : null;
    this.projectRequestId = $obj && $obj.projectRequestId ? $obj.projectRequestId : null;
    this.projectId = $obj && $obj.projectId  ? $obj.projectId : null;
    this.requirementFileId = $obj && $obj.requirementFileId  ? $obj.requirementFileId : null;
    this.taskId = $obj && $obj.taskId  ? $obj.taskId : null;
    this.meetingId = $obj && $obj.meetingId  ? $obj.meetingId : null;
    this.commentId = $obj && $obj.commentId  ? $obj.commentId : null;
    this.budgetId = $obj && $obj.budgetId  ? $obj.budgetId : null;
    this.artifactId = $obj && $obj.artifactId  ? $obj.artifactId : null;
    this.contractId = $obj && $obj.contractId  ? $obj.contractId : null;
    this.productId = $obj && $obj.productId  ? $obj.productId : null;
    this.proposalId = $obj && $obj.proposalId  ? $obj.proposalId : null;
    this.templateId = $obj && $obj.templateId  ? $obj.templateId : null;
    this.eventFileId = $obj && $obj.eventFileId  ? $obj.eventFileId : null;
    this.wikiId = $obj && $obj.wikiId  ? $obj.wikiId : null;
    this.tripId = $obj && $obj.tripId  ? $obj.tripId : null;

    this.uploadBy = $obj && $obj.uploadBy  ? new User($obj.uploadBy) : null;

    this.deleted = $obj && $obj.deleted ? $obj.deleted : false;
    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.deletedAt = $obj && $obj.deletedAt ? new Date($obj.deletedAt) : new Date();
  }

  createFromFile(f: File, urlSanitize: any) {
    this.originalname = f.name;
    this.filename = f.name;
    this.mimetype = f.type;
    this.size = f.size;
    this.urlSanitize = urlSanitize;
    return this;
  }

  /**
   * @description Format the file size
   */
  get fileSize() {
    const bytes = this.size;
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * @description Get file icon by file type
   * @returns fontawesome icon
   */
  get fileIcon() {
    const fileType = this.mimetype;
    if (fileType.includes('pdf')) return 'mdi mdi-file-pdf-box';
    else if (fileType.includes('excel') || fileType.includes('sheet')) return 'mdi mdi-file-excel';
    else if (fileType.includes('csv')) return 'mdi mdi-file-table';
    else if (fileType.includes('zip') || fileType.includes('rar')) return 'mdi mdi-folder-zip';
    else if (fileType.includes('odt') || fileType.includes('word')) return 'mdi mdi-file-word';
    else if (fileType.includes('html') || fileType.includes('javascript') || fileType.includes('css')) return 'mdi mdi-file-code';
    else return 'mdi mdi-file-document';
  }
}
